import { Modal } from "antd";
import React from "react";
import { svg } from "../../../../../Assets/svg";
import { momentFullTime } from "../../../../../helpers/utils";

const MachineConflictModal: React.FC<{
  visible: boolean;
  setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: any;
  isMachinConflctData: any;
}> = ({ visible, setIsModalVisible, onClose, isMachinConflctData }) => {
  return (
    <Modal
      title={
         <div className="text-center fs-4 fw-bolder lh-m">
          Machine Already Scheduled for Order #
          {isMachinConflctData?.order_number}. Please Change!
        </div>
      }
      visible={visible}
      onCancel={onClose}
      width={"32.813rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary min-w-130"
            onClick={onClose}
          >
            CLOSE
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <div className="modal-body page-form">
        <p className="fs-6 mt-3 text-center text-4a4a4a">
          This machine is already assigned to Order #
          <strong> {isMachinConflctData?.order_number}</strong> for the{" "}
          <strong> {isMachinConflctData?.product_name}</strong> product from{" "}
          <strong> {momentFullTime(isMachinConflctData?.start_date)}</strong> to{" "}
          <strong> {momentFullTime(isMachinConflctData?.end_date)}</strong>
          .Please select a different machine or update the existing schedule
          before continuing.
        </p>
      </div>
    </Modal>
  );
};

export default MachineConflictModal;
